// extracted by mini-css-extract-plugin
export default {"form":"style_form__zskNI","title":"style_title__SS1pq","forgot":"style_forgot__AtLLW","alreadyUser":"style_alreadyUser__KQnUZ","button":"style_button__tvTwt"};